import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import { InsertPlaceholderInputDirective } from '../insert-placeholder-input.directive';
import { Placeholder } from '../placeholder';
import { PlaceholderService } from '../placeholder.service';

@Component({
  selector: 'rt-placeholder-select-dropdown',
  templateUrl: './placeholder-select-dropdown.component.html',
  styleUrls: ['./placeholder-select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceholderSelectDropdownComponent {
  @Input() public placeholders: Placeholder[];
  @Input() public activeTarget: InsertPlaceholderInputDirective | undefined;
  @Input() public category: string;
  @Input() public showHeader: boolean;
  @Input() public active: Placeholder;

  @Output() public select = new EventEmitter<Placeholder>();
  @Output() public back = new EventEmitter<void>();

  public placeholdersByCategory: Placeholder[];
  public placeholderCategoryTranslationMap =
    this.placeholderService.placeholderCategoryTranslationMap;

  constructor(private cdRef: ChangeDetectorRef, private placeholderService: PlaceholderService) {}

  public goBack(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.back.emit();
  }

  public trackByName(index: number, placeholder: Placeholder): string {
    return placeholder.id;
  }

  public withoutBrackets(str: string): string {
    return str.slice(1, -1);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.placeholders) {
      this.placeholdersByCategory = this.placeholders.filter(placeholder =>
        placeholder.id.includes(`${this.category}.`),
      );
    }
  }
}
